import React, { lazy, Suspense, useEffect, useState } from 'react';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { MetaPixel } from './components/MetaPixel';
const DeferredLanding = lazy(() => import('./components/DeferredLanding').then(({
  DeferredLanding: Component
}) => ({
  default: Component
})));
export function App() {
  const [loadDeferredContent, setLoadDeferredContent] = useState(false);
  useEffect(() => {
    document.title = 'Visual Chemistry™ | Ready-to-Use Chemistry Resources for Teachers';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'A complete digital chemistry teaching system with visual theory pages, printable worksheets, classroom activities, assessments, answer keys, and ready-to-use resources for the entire school year.');
    const timer = window.setTimeout(() => setLoadDeferredContent(true), 900);
    return () => window.clearTimeout(timer);
  }, []);
  return <div className="w-full bg-paper text-ink" data-id="element-0" data-mp="6hrlipoilfp">
      <MetaPixel data-id="element-1" data-mp="56ntiw8hdol" />
      <StickyHeader data-id="element-2" data-mp="7sulgbavp5r" />
      <main data-id="element-3" data-mp="2zld2xbxu5jcl">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-4" data-mp="2zllijblcf2rh" />
        <Hero data-id="element-5" data-mp="2zn6biws0edn8" />
        <SocialProofBar data-id="element-6" data-mp="33mou3lwcycmw" />
        {loadDeferredContent && <Suspense fallback={<div className="h-10 bg-paper" aria-hidden="true" data-id="element-8" data-mp="33orjq4tlm3r3" />} data-id="element-7" data-mp="33n6y54p9hv5d">
            <DeferredLanding data-id="element-9" data-mp="38l03xwmnkn54" />
          </Suspense>}
      </main>
    </div>;
}